module.exports = __webpack_public_path__ + "assets/img/volume-fill.86ce4903.svg";